<template>
  <div class="main d-flex justify-content-center align-items-center">
    <div class="main-container">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <img
          class="img-logomarca"
          src="../assets/logomarca.svg"
          alt="Logomarca Cogumelos Umami"
        />
        <span class="mb-2">cogumelos</span>
        <img
          class="img-logotipo"
          src="../assets/logotipo.svg"
          alt="Logotipo Cogumelos Umami"
        />
      </div>

      <b-form
        @submit.prevent="login"
        class="d-flex flex-column justify-content-center align-items-center"
      >
        <b-form-group class="mb-2">
          <label class="px-2 mb-1" for="email">Seu email</label>
          <b-form-input
            v-model="user.email"
            name="email"
            class="mb-3"
            id="email"
            type="email"
            required
            placeholder="compjunior@compjunior.com.br"
          ></b-form-input>
        </b-form-group>

        <b-form-group class="mb-3">
          <label class="px-2 mb-1" for="senha">Sua senha</label>
          <b-form-input
            v-model="user.password"
            class="mb-2"
            id="senha"
            type="password"
            required
            placeholder="compJunior"
          ></b-form-input>
        </b-form-group>

        <div class="check-link mb-2 px-2">
          <b-form-checkbox
            v-model="rememberLogin"
            id="remember"
            name="remember"
          >
            Lembrar login
          </b-form-checkbox>
          <router-link to="/esqueci-senha" class="text-decoration-none">
            <span class="forgot-password">Esqueci minha senha</span>
          </router-link>
        </div>
        <button class="btn-submit mt-2">ENTRAR</button>
      </b-form>
    </div>
  </div>
</template>

<script>
import { Login } from '../services/Auth';
import showError from '../utils/showError';
import { GetCookie, SetCookie } from '../utils/Cookie';

export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
      rememberLogin: false,
    };
  },
  created() {
    if (GetCookie('token')) {
      this.$router.push('/produtos');
    } else {
      localStorage.removeItem('__cogumelos_umami_user');

      const storedEmail = localStorage.getItem('__cogumelos_umami_email');
      if (storedEmail) {
        this.user.email = storedEmail;
        this.rememberLogin = true;
      } else {
        this.rememberLogin = false;
      }
    }
  },
  methods: {
    async login() {
      if (this.rememberLogin) {
        localStorage.setItem('__cogumelos_umami_email', this.user.email);
      } else {
        localStorage.removeItem('__cogumelos_umami_email');
      }

      await Login(this.user)
        .then((res) => {
          this.$store.commit('setUser', res.data);
          SetCookie('token', res.data.token, {
            expires: res.data.tokenExpiration,
          });
          localStorage.setItem(
            '__cogumelos_umami_user',
            JSON.stringify(res.data)
          );
          this.$router.push('/produtos');
        })
        .catch((e) => {
          showError(e);
        });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Kameron&display=swap');

.main {
  min-height: 100vh;
  width: 100vw;

  background: linear-gradient(180deg, #e5e5e5 50%, #be8250 50%);

  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #ffffff;
  overflow: auto;
}

.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 80px;

  height: fit-content;
  max-height: fit-content;
  padding: 3rem 5rem 3rem;

  box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.42);
}

span {
  font-family: 'Kameron', serif;
  font-size: 36px;
  color: #4b687a;
}

.img-logomarca {
  width: 200px;
  height: 230px;
}

.img-logotipo {
  width: 300px;
  height: 40px;
}

::-webkit-input-placeholder {
  font-size: 16px;
  color: #615f5f;
}

input {
  width: 280px;
  border-radius: 12px;
  border: none;
  background-color: #eeeeee;
}

input:focus {
  box-shadow: 0 0 8px 2px #d65600;
}

.check-link {
  display: flex;
  align-items: center;
  gap: 36px;
  font-size: 15px;
}

.forgot-password {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

.forgot-password:hover {
  color: #ffffff;
}

.btn-submit {
  color: #d0723e;
  font-size: 15px;
  background: #eeeeee;
  border: 1px solid #d65600;
  border-radius: 12px;
  width: 230px;
  padding: 2px 0;
}

.btn-submit:hover {
  background: #d6d5d5;
}

.btn-submit:focus {
  outline: none;
  border: none;
}

@media (min-width: 720px) {
  .main {
    background: linear-gradient(135deg, #e5e5e5 50%, #be8250 50%);
  }

  .main-container {
    flex-direction: row;
    gap: 360px;
    width: fit-content;
    max-width: fit-content;
  }
}
</style>
